// extracted by mini-css-extract-plugin
export default {"settings-button":"SettingsButton_settings-button__aiSNg"};